import { setVisible, OTPCodeValidFormat } from "../helpers"

import { VanillaOTP } from "../../libs/index"
import { ssrExportAllKey } from "vite/module-runner"
import { type SessionCreateResponse } from "../models/session-create-response"
import type { AuthService } from "../services/auth.service"

export class OTPDiag {
  sendBtn: HTMLButtonElement
  errorElem: HTMLElement
  successElem: HTMLElement
  OTPInputs: Array<HTMLInputElement>
  email: string
  emailElem: HTMLSpanElement
  existingUser: boolean
  autoCloseIntervalID: number

  constructor(
    private element: HTMLElement,
    private loginSuccessCallback: Function,
    private authService:AuthService = window.tbwServices.authService
  ) {
    const errorElem = this.element.querySelector<HTMLElement>('.error-container')
    const successElem = this.element.querySelector<HTMLElement>('.success-container')
    const OTPInputs = Array.from<HTMLInputElement>(this.element.querySelectorAll('.otp-input'))
    const emailElem = element.querySelector('#otp-send-email') as HTMLSpanElement
    const resendBtn = element.querySelector('#resendBtn') as HTMLButtonElement
    
    const elementMissing = !errorElem || !successElem || !OTPInputs || !resendBtn
    if (elementMissing) { throw new Error('Element(s) missing') }

    this.errorElem = errorElem
    this.successElem = successElem
    this.OTPInputs = OTPInputs
    this.emailElem = emailElem
    let resendEmailTimeId: number | undefined;
    resendBtn.addEventListener('click', () => {
      clearInterval(resendEmailTimeId)
      resendEmailTimeId = setTimeout(() => authService.sendEmail(this.email), 5000)
    })

    const hiddenInput = this.element.querySelector("#otpHidden") as HTMLInputElement
    hiddenInput.hidden = true
    const otp = new VanillaOTP(
      this.element.querySelector('.otp-container'),
      hiddenInput,
      (_e: Event) => this.onOTPInputChanged(otp.getValue())
    )
  }

  onOTPInputChanged(otpCode: string) {
    if ((+otpCode).toString().length === 6) { this.send() }
  }

  open(email: string) {
    this.OTPInputs.forEach(i => { i.disabled = false; i.value = '' })
    this.email = email
    setVisible(this.successElem, false)
    setVisible(this.errorElem, false)
    this.emailElem.innerText = this.email
  }

  clear() { this.OTPInputs.forEach(i => i.value = '') }

  parseOTPInputs = (inputs: Array<HTMLInputElement>) => +inputs.map(i => i.value).reduce((a, b) => a + b)

  send = async () => {
    const OTPCode = this.parseOTPInputs(this.OTPInputs)
    if (!OTPCodeValidFormat(OTPCode)) { return false }

    this.OTPInputs.forEach(i => i.disabled = true)
    setVisible(this.errorElem, false)

    const session = await this.authService.verifyOTP(this.email, OTPCode)
    session ? this.onOTPValidResponse(session) : this.onOTPInvalidResponse()
  }

  onOTPInvalidResponse = () => {
    setVisible(this.errorElem, true)
    const setInvalidAndEnabled = (i: HTMLInputElement) => { i.classList.add('invalid'); i.classList.remove('valid'); i.disabled = false }
    this.OTPInputs.forEach(setInvalidAndEnabled)
    this.OTPInputs[this.OTPInputs.length - 1].focus()
  }

  onOTPValidResponse = (session: SessionCreateResponse) => {
    setVisible(this.successElem, true)
    const setValid = (i: HTMLElement) => { i.classList.add('valid'); i.classList.remove('invalid') }
    this.OTPInputs.forEach(setValid)
    this.loginSuccessCallback(session)
  }
}
